import React from "react";
import RangeDataOptionTotalizado from "./RangeDataOptionTotalizado";
import { getRUCEmpresa } from "redux/actions/userActions";
import { useSelector } from "react-redux";
//libreria de consulta de apis
import { httpRepo } from "configurations/axios";
import { useSnackbar } from "notistack";
import { makeStyles, CircularProgress, Backdrop } from "@material-ui/core";
import { parseDate } from "utils/checkDate";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "350px",
  },
  backdrop: {
    zIndex: "3000",
    color: "#fff",
  },
}));

// Rango máximo permitido entre fecha inicial y fecha final
const MESES_MAXIMO_RANGO = 3;

const VoucherReportAuthorizedTotal = () => {
  const tokenUser = useSelector((state) => state.user.tk);
  const { enqueueSnackbar } = useSnackbar();
  var fileSaver = require("file-saver");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  function excedeRangoMaximo(startDate, endDate) {
    const limite = new Date(startDate);
    limite.setMonth(limite.getMonth() + MESES_MAXIMO_RANGO);
    return new Date(endDate) > limite;
  }

  function generateReport(startDate, endDate) {
    if (excedeRangoMaximo(startDate, endDate)) {
      enqueueSnackbar(
        `El rango entre fecha inicial y fecha final no puede ser mayor a ${MESES_MAXIMO_RANGO} meses`,
        {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          autoHideDuration: 4000,
        }
      );
      return;
    }

    const objReport = {
      fechaFin: parseDate(endDate, 2),
      fechaInicio: parseDate(startDate, 1),
      rucEmpresa: tokenUser ? getRUCEmpresa(tokenUser) : "",
    };
    getReportIssued(objReport);
  }

  const getReportIssued = async (objReport) => {
    setOpen(true);
    await httpRepo
      .post("reporte/comprobantes/emitidos/totalizado", objReport, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (response.status === 200) {
          var blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileSaver.saveAs(blob, "ReporteComprobantesAutorizadosTotalizado.xlsx");
          setOpen(false);
        }
      })
      .catch(() => {
        enqueueSnackbar(`No existen datos para los filtros seleccionados`, {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setOpen(false);
      });
  };

  return (
    <div>
      <Backdrop open={open} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <RangeDataOptionTotalizado
        generateReport={generateReport}
        title={"Reporte de Comprobantes Autorizados Totalizado."}
      ></RangeDataOptionTotalizado>
    </div>
  );
};

export default VoucherReportAuthorizedTotal;
